export const privacyContent = {
  companyName: '주식회사 서울소프트',
  companyNameEn: 'Seoul-Soft Co., Ltd.',
  serviceName: 'EasyAutoCall',

  // 회사 정보
  companyInfo: {
    ceo: '노병진',
    businessNumber: '134-87-18556',
    headquarters: '충청북도 충주시 중앙로 80 (네오메디클리닉), 501호',
    researchLab: '서울특별시 금천구 가산디지털1로 84, 810호',
    tel: '02-6052-1192',
    fax: '02-600-9349',
    email: 'hshwang@seoul-soft.com',
    privacyOfficer: {
      name: '개인정보보호책임자',
      department: '서비스운영팀',
      email: 'hshwang@seoul-soft.com',
      tel: '02-6052-1192'
    }
  },

  effectiveDate: '2025년 1월 1일',

  sections: [
    { title: '제1조 (개인정보의 처리 목적)', content: `회사는 다음의 목적을 위하여 개인정보를 처리합니다.\n1. 회원가입 및 관리: 본인확인, 서비스 이용자 식별, 부정이용 방지\n2. 서비스 제공: TTS 발신 및 설문 서비스, 결제 및 크레딧 관리, 통계 분석\n3. 고객 응대: 문의·불만 처리, 고지·통지 및 민원 대응` },
    { title: '제2조 (처리하는 개인정보의 항목)', content: `1. 회원가입 시\n   - 필수: 이름, 이메일, 비밀번호, 회사명\n   - 선택: 직책, 전화번호\n2. 서비스 이용 시\n   - 로그기록(IP, 접속기기정보, 이용일시), 결제정보(카드사명, 승인번호)` },
    { title: '제3조 (개인정보의 처리 및 보유기간)', content: `1. 회원탈퇴 시 즉시 파기\n2. 단, 다음의 경우 법령에 따라 일정기간 보관\n   - 계약 및 청약철회 등 거래기록: 5년\n   - 대금결제 및 재화공급 기록: 5년\n   - 소비자 불만 및 분쟁처리 기록: 3년\n   - 접속 로그기록: 3개월` },
    { title: '제4조 (개인정보의 제3자 제공)', content: `회사는 원칙적으로 정보주체의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 근거가 있거나 수사기관 요청 시 예외로 합니다.` },
    { title: '제5조 (개인정보 처리의 위탁)', content: `회사는 서비스 운영을 위해 다음과 같이 개인정보 처리를 위탁할 수 있습니다.\n   - 수탁업체: 주식회사 코리아포트원 / 업무: 결제처리 / 보유기간: 거래 완료 후 5년\n   - 수탁업체: AWS / 업무: 서비스 서버 운영 / 보유기간: 회원탈퇴 또는 위탁계약 종료 시까지` },
    { title: '제6조 (개인정보의 국외 이전)', content: `회사는 클라우드 서비스(AWS)를 통해 해외(일본 도쿄 리전)에 데이터를 저장할 수 있습니다. 이전 목적은 시스템 운영이며, 암호화 및 접근통제를 통해 안전하게 관리합니다.` },
    { title: '제7조 (정보주체의 권리와 행사 방법)', content: `정보주체는 언제든지 개인정보 열람, 정정, 삭제, 처리정지를 요구할 수 있습니다.\n요청은 이메일 또는 서면으로 접수 가능하며, 회사는 10일 이내 처리합니다.` },
    { title: '제8조 (개인정보의 파기)', content: `1. 파기 사유 발생 시 즉시 파기\n2. 전자적 파일: 복구 불가능한 방법으로 삭제\n3. 서면 자료: 분쇄 또는 소각 처리` },
    { title: '제9조 (개인정보의 안전성 확보조치)', content: `1. 관리적 조치: 내부관리계획 수립, 직원 교육\n2. 기술적 조치: 접근권한 관리, 암호화, 보안프로그램\n3. 물리적 조치: 서버 접근통제, 자료보관실 잠금관리` },
    { title: '제10조 (쿠키 및 로그 수집)', content: `회사는 서비스 개선과 맞춤형 서비스 제공을 위해 쿠키를 사용합니다.\n이용자는 브라우저 설정을 통해 쿠키 저장을 거부할 수 있습니다.` },
    { title: '제11조 (개인정보 보호책임자)', content: `성명: 개인정보보호책임자\n부서: 서비스운영팀\n이메일: hshwang@seoul-soft.com\n연락처: 02-6052-1192` },
    { title: '제12조 (권익침해 구제방법)', content: `- 개인정보침해신고센터: privacy.kisa.or.kr / 118\n- 개인정보분쟁조정위원회: www.kopico.go.kr / 1833-6972\n- 경찰청 사이버안전국: 182` },
    { title: '제13조 (개인정보 처리방침 변경)', content: `본 방침은 2025년 1월 1일부터 시행하며, 변경 시 서비스 내 공지사항을 통해 고지합니다.` }
  ]
};
